import {Component, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoDirective} from '@jsverse/transloco';
import {AdditionalConditionsType, Campaign, getLoyaltyLevel, Size,} from '../../../services/model';
import {PillLoyaltyComponent} from '../../pill-loyalty/pill-loyalty.component';
import {PillLogoComponent} from '../../pill-logo/pill-logo.component';
import {OrdinalNumberPipe} from '../../pipes/ordinal-number.pipe';
import {PillColor} from '../../models';
import {LoyaltyCurrencyPipe} from '../../pipes/loyalty-currency.pipe';

@Component({
  selector: 'lib-campaign-card-sentence-merchant',
  imports: [
    CommonModule,
    TranslocoDirective,
    PillLoyaltyComponent,
    LoyaltyCurrencyPipe,
    PillLogoComponent,
    OrdinalNumberPipe,
  ],
  providers: [LoyaltyCurrencyPipe],
  templateUrl: './campaign-card-sentence-merchant.component.html',
  styleUrl: './campaign-card-sentence-merchant.component.scss',
})
export class CampaignCardSentenceMerchantComponent {
  campaign = input.required<Campaign>();

  reward = computed<string>(() => {
    return this.currencyPipe.transform(this.campaign().reward) ?? '';
  });

  size = input<Size>(Size.BIG);
  highContrast = input<boolean>(false);

  cashbackFor = computed(() => {
    switch (this.campaign().additionalConditions?.additionalConditionsType) {
      case AdditionalConditionsType.NUMBER_OF_TRANSACTIONS:
        return 'actions.card.sentence.cashbackOnVisit';
      case AdditionalConditionsType.AMOUNT_SPENT:
        return 'actions.card.sentence.cashbackForSpending';
      case AdditionalConditionsType.LOYALTY:
        return 'actions.card.sentence.cashbackForBeing';
      default:
        return null;
    }
  });

  pillColor = computed<PillColor>(() => this.highContrast() ? PillColor.NEUTRAL_200 : PillColor.NEUTRAL_200);

  readonly classes = computed<SentenceClasses>(() => {
    return {
      container: {[this.size().toLowerCase()]: true, ['high-contrast']: this.highContrast()},
      pill: this.getPillClass()
    };
  });

  private getPillClass(): any {
    if (this.highContrast()) {
      return;
    }

    return {
      [this.campaign().userLoyalty.level.toLowerCase().trim()]: true,
    };
  }

  constructor(private currencyPipe: LoyaltyCurrencyPipe) {
  }

  protected readonly AdditionalConditionsType = AdditionalConditionsType;
  protected readonly Size = Size;
  protected readonly getLoyaltyLevel = getLoyaltyLevel;
}

interface SentenceClasses {
  container: any,
  pill: any
}
